import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: 'How technical do I need to be?',
    answer: "Not technical at all. This bootcamp is designed for leaders, not engineers. We teach you how to think strategically about AI, redesign workflows, and lead transformation—not how to code. If you can use email and a web browser, you're ready."
  }, {
    question: "Is this suitable if we're already running AI pilots?",
    answer: 'Absolutely. Many participants come with some AI experience but lack strategic clarity, governance frameworks, or a cohesive roadmap. This bootcamp helps you move from scattered experiments to systematic transformation with clear ownership and metrics.'
  }, {
    question: 'Can I bring my family to Cancun?',
    answer: "Yes! While the bootcamp is intensive, you're welcome to bring family. Hard Rock Hotel Cancun is family-friendly. Just note that the program runs from early morning to evening, so plan accordingly. Family members can enjoy the resort while you're in sessions."
  }, {
    question: 'Is this only for one industry?',
    answer: 'No. We work with leaders across industries—finance, healthcare, manufacturing, professional services, tech, retail, and more. The curriculum is industry-agnostic but includes industry-specific breakout sessions and peer groups during labs.'
  }, {
    question: 'What happens after the bootcamp?',
    answer: 'You leave with a 90-day action plan, 12-month roadmap, and working prototypes. We also provide a 60-minute post-bootcamp implementation clinic (Individual Pass) or multiple follow-up sessions (Team/Corporate). Plus, you join our alumni network for ongoing support.'
  }, {
    question: "What's the refund/cancellation policy?",
    answer: 'Full refund if you cancel 60+ days before the cohort start date. 50% refund if you cancel 30-59 days before. No refund within 30 days of start date. We can transfer your spot to another cohort if needed (subject to availability).'
  }, {
    question: 'Can we host this program privately for our company in another destination?',
    answer: 'Yes. For corporate cohorts of 15+ participants, we can customize the program and deliver it at a destination of your choice (subject to venue availability and logistics). Contact us for a discovery call to discuss options.'
  }, {
    question: 'Do you offer payment plans or corporate invoicing?',
    answer: 'Yes. We accept corporate purchase orders and can arrange payment plans for teams and corporate cohorts. Individual leaders pay upfront. Contact us to discuss payment options that work for your organization.'
  }];
  return <section className="py-24" data-id="element-173">
      <div className="max-w-4xl mx-auto px-6" data-id="element-174">
        <div className="text-center mb-16" data-id="element-175">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-176">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-slate-400" data-id="element-177">
            Everything you need to know about the AI Leadership
            Hyper-Accelerator
          </p>
        </div>

        <div className="space-y-4" data-id="element-178">
          {faqs.map((faq, index) => <div key={index} className="bg-slate-800/50 border border-slate-700 rounded-xl overflow-hidden hover:border-slate-600 transition-all duration-300" data-id="element-179">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left" data-id="element-180">
                <span className="text-lg font-semibold text-white pr-4" data-id="element-181">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-slate-400 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-182" />
              </button>

              {openIndex === index && <div className="px-6 pb-5" data-id="element-183">
                  <p className="text-slate-300 leading-relaxed" data-id="element-184">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}